import { Injectable } from '@angular/core';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';
import { AppState } from './app.service';
import { I18n } from './i18n.service';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  private DURATION = 2000 ;  

  constructor(
    public toast: ToastController,
    private alertController: AlertController,
    private i18n: I18n)
  { }

  async showRecommitConfirm(onYes: () => void, onNo?: () => void, completedAt?: string): Promise<void> {
    const message = completedAt
      ? this.i18n.t("You've already completed this action on ") + completedAt + "." + this.i18n.t(" Would you like to customize and commit to it again?")
      : this.i18n.t("You've already completed this action. Would you like to customize and commit to it again?");
    return this.showConfirm(message, onYes, onNo);
  }

  /**
   * Yes/No over any message, in the same styling the recommit prompt uses. For anything the learner
   * should not be able to do by mistake — deleting history, most of all.
   */
  async showConfirm(message: string, onYes: () => void, onNo?: () => void): Promise<void> {
    const alert = await this.alertController.create({
      message,
      cssClass: 'recommit-confirm-alert',
      buttons: [
        {
          text: this.i18n.t("No"),
          role: 'cancel',
          cssClass: 'recommit-cancel-btn',
          handler: () => { if (onNo) onNo(); },
        },
        {
          text: this.i18n.t("Yes"),
          cssClass: 'recommit-yes-btn',
          handler: () => { onYes(); },
        },
      ],
    });
    await alert.present();
  }

  success(message: string = null, pos:any="top", className:any='success-toaster-class'){
    this.toast.create({
      message: this.i18n.t(message),
      position: pos,
      cssClass: className,
      duration: this.DURATION
    }).then((obj) => {
      obj.present();
    });
  }

  warning(message: string = null){
    this.toast.create({
      message: this.i18n.t(message),
      position: 'top',
      cssClass: 'warning-toaster-class',
      duration: this.DURATION
    }).then((obj) => {
      obj.present();
    });
  }

  error(message: string = null){
    this.toast.create({
      message: this.i18n.t(message),
      position: 'top',
      cssClass: 'error-toaster-class',
      duration: this.DURATION
    }).then((obj) => {
      obj.present();
    });
  }


}
